module.exports = __webpack_public_path__ + "static/error-page-level-example-f298e60b7b3fdd9a3648bbc71443afdd.svg";